module.exports = __webpack_public_path__ + "img/7.925d224d.png";